import HeadNext from 'next/head';
import {FC, PropsWithChildren} from 'react';

interface IProps {
  title: string;
  description?: string;
}

export const Head: FC<PropsWithChildren<IProps>> = ({children, title, description}) => {
  return (
    <HeadNext>
      <title>{title}</title>
      <meta name="description" content={description} />
      {children}
    </HeadNext>
  );
};
